import { render } from "./Nutritionists.vue?vue&type=template&id=b2da09e2&scoped=true"
const script = {}

import "./Nutritionists.vue?vue&type=style&index=0&id=b2da09e2&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2da09e2"]])

export default __exports__